import Vue from 'vue';

const success = (context, response) => {
  context.smallLoading = false;
  context.closeModal('#configure-nuki-lock');
  toastr.success(context.$t('account.settings.user_services_section.igloohome.sync_lock_success'));
};

const failed = (context, error) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (context, apiKey) => Vue.$http.post('sync-nuki-locks', {apiKey})
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    }).catch(error => {
      failed(context, error);
  })



// WEBPACK FOOTER //
// ./src/app/services/account/syncNukiLocks.js